import type { WidgetContextResponse } from './types';

export function resolveEmbedApiBaseUrl(explicit?: string): string {
    if (explicit) {
        return explicit.replace(/\/$/, '');
    }

    if (typeof document !== 'undefined') {
        const script = document.querySelector<HTMLScriptElement>(
            'script[src*="votiq.widget"]',
        );

        if (script?.src) {
            try {
                return new URL(script.src).origin;
            } catch {
                // ignore invalid script URL
            }
        }
    }

    if (typeof window !== 'undefined') {
        return window.location.origin;
    }

    return '';
}

export async function fetchWidgetContext(
    projectId: string,
    params: { context?: string | null; page?: string | null; feature?: string | null },
    apiBaseUrl?: string,
): Promise<WidgetContextResponse> {
    const base = resolveEmbedApiBaseUrl(apiBaseUrl);
    const url = new URL(
        `/api/widget/v1/projects/${encodeURIComponent(projectId)}/context`,
        base || undefined,
    );

    if (params.context) {
        url.searchParams.set('context', params.context);
    }

    if (params.page) {
        url.searchParams.set('page', params.page);
    }

    if (params.feature) {
        url.searchParams.set('feature', params.feature);
    }

    const response = await fetch(url.toString(), {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'omit',
    });

    if (!response.ok) {
        throw new Error(`Context request failed (${response.status})`);
    }

    return (await response.json()) as WidgetContextResponse;
}
